import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	showMoreTooltip: {
		id: 'issue-field-labels-readview-full.labels.compact.show-more-tooltip',
		defaultMessage: 'See more labels',
		description: 'Label for trigger button to open a dialog with a list of labels',
	},
	noValueTextExperiment: {
		id: 'issue-field-labels-readview-full.labels.compact.no-value-text-experiment',
		defaultMessage: 'Add labels',
		description: 'Message when a field has no value',
	},
});
